import type { GetStaticProps } from 'next'
import type { FC } from 'react'
import type { Category, Product } from '@/types'

import { Seo } from '@/components/generals/seo'
import { SiteLayout } from '@/components/layout/site-layout'
import { MouseParallax } from '@/components/animations/mouse-parallax'
import { Newsletter } from '@/components/sections/newsletter'
import { Hero } from '@/components/home/hero'
import { CategoryShowcase } from '@/components/home/category-showcase'
import { ProductSection } from '@/components/home/product-section'
import { SaleCta } from '@/components/home/sale-cta'
import { Features } from '@/components/home/features'

import { getLayoutData } from '@/lib/layout-data'
import { getProducts } from '@/lib/collections'

interface HomeProps {
    categories: Category[]
    newest: Product[]
    trending: Product[]
}

const DESCRIPTION =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Porta feugiat etiam aliquet aliquet tellus vel. Et maecenas id bibendum sit. Augue nulla tortor faucibus nunc. Urna massa mattis faucibus velit sed volutpat sodales. Quis at mi amet, ipsum.'

const Home: FC<HomeProps> = ({ categories, newest, trending }) => {
    return (
        <SiteLayout categories={categories} isHome>
            <Seo />

            <Hero />

            <CategoryShowcase categories={categories} />

            <ProductSection
                containerClassName='container'
                titleLeft='NEWEST'
                titleRight='PRODUCTS'
                description={DESCRIPTION}
                products={newest}
                descId='w-node-bd183f7b-154c-980d-b9b1-bc5390021e83-ee6eeb4f'
                buttonId='w-node-_99f7b184-4651-a5c3-c4c9-444ef4eefee1-ee6eeb4f'
            />

            <SaleCta />

            <ProductSection
                id='Season'
                containerClassName='container _6ems'
                titleLeft="SEASON'S"
                titleRight='TRENDING'
                description={DESCRIPTION}
                products={trending}
                descId='w-node-_0ab7d26e-83c9-9d10-7b38-ca31ec89dd37-ee6eeb4f'
                buttonId='w-node-_0ab7d26e-83c9-9d10-7b38-ca31ec89dd3a-ee6eeb4f'
            />

            <Features />

            <Newsletter />

            <div className='blured-circle-holder'>
                <div className='hero-blured-circle'>
                    <img src='/images/Blured-Elipse.png' loading='lazy' alt='' className='hero-blured-circle-image' />
                </div>
            </div>

            <MouseParallax target='.hero-blured-circle' xRange={50} yRange={50} />
        </SiteLayout>
    )
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    const { categories } = getLayoutData()
    const products = getProducts()

    return {
        props: {
            categories,
            newest: products.slice(0, 4),
            trending: products.slice(4, 8)
        }
    }
}

export default Home
